import { render, staticRenderFns } from "./PrivacyInApp.vue?vue&type=template&id=d20ecefc&scoped=true&"
import script from "./PrivacyInApp.vue?vue&type=script&lang=js&"
export * from "./PrivacyInApp.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyInApp.vue?vue&type=style&index=0&id=d20ecefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ecefc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
